<script>
import SftpForm from '../uploadServices/SftpForm.vue'
import LargeTabHeader from "@/components/common/tabs/LargeTabHeader.vue";

export default {
  components: {
    LargeTabHeader,
    SftpForm
  },
  data() {
    return {}
  }
}
</script>
<template>
  <v-container fluid>
    <!--    HEADER-->
    <LargeTabHeader
      :title="$t('component.profile.tabs.uploadServicesTab.title')"
      :subtitle="$t('component.profile.tabs.uploadServicesTab.subtitle')"/>

    <v-divider></v-divider>

      <!--    SFTP FORM -->
    <v-row class="justify-center">
      <v-col cols="8">
        <SftpForm/>
      </v-col>
    </v-row>
  </v-container>
</template>
